/**
 * 
 * @param {*} controller string | nombre del controller en la api
 * @returns un objeto con constantes para operaciones asincronicas
 */
export const constants = (controller) => ({
  KEY_VALUE: {
    REQUEST: `${controller}_KEY_VALUE_REQUEST`,
    SUCCESS: `${controller}_KEY_VALUE_SUCCESS`,
    FAILURE: `${controller}_KEY_VALUE_FAILURE`,
  },
  INDEX: {
    REQUEST: `${controller}_INDEX_REQUEST`,
    SUCCESS: `${controller}_INDEX_SUCCESS`,
    FAILURE: `${controller}_INDEX_FAILURE`,
    UPDATE_ITEM: `${controller}_INDEX_UPDATE_ITEM`,
    ADD_ITEM: `${controller}_INDEX_ADD_ITEM`,
  },
  SCHEMA: {
    REQUEST: `${controller}_SCHEMA_REQUEST`,
    SUCCESS: `${controller}_SCHEMA_SUCCESS`,
    FAILURE: `${controller}_SCHEMA_FAILURE`,
  },  
  SCHEMA_FORM: {
    REQUEST: `${controller}_SCHEMA_FORM_REQUEST`,
    SUCCESS: `${controller}_SCHEMA_FORM_SUCCESS`,
    FAILURE: `${controller}_SCHEMA_FORM_FAILURE`,
  },
  LOAD_MORE: {
    REQUEST: `${controller}_LOAD_MORE_REQUEST`,
    SUCCESS: `${controller}_LOAD_MORE_SUCCESS`,
    FAILURE: `${controller}_LOAD_MORE_FAILURE`,
  },
  FILTER: {
    REQUEST: `${controller}_FILTER_REQUEST`,
    SUCCESS: `${controller}_FILTER_SUCCESS`,
    FAILURE: `${controller}_FILTER_FAILURE`,
    CLEAR  : `${controller}_FILTER_CLEAR`,
    UPDATE_ITEM: `${controller}_FILTER_UPDATE_ITEM`,
  },  
  GET_ITEM: {
    REQUEST: `${controller}_GET_ITEM_REQUEST`,
    SUCCESS: `${controller}_GET_ITEM_SUCCESS`,
    FAILURE: `${controller}_GET_ITEM_FAILURE`,
  },
  ADD_ITEM: {
    REQUEST: `${controller}_ADD_ITEM_REQUEST`,
    SUCCESS: `${controller}_ADD_ITEM_SUCCESS`,
    FAILURE: `${controller}_ADD_ITEM_FAILURE`,
  },
  ADD_ITEM_SECTION: {
    REQUEST: `${controller}_ADD_ITEM_SECTION_REQUEST`,
    SUCCESS: `${controller}_ADD_ITEM_SECTION_SUCCESS`,
    FAILURE: `${controller}_ADD_ITEM_SECTION_FAILURE`,
  },
  EDIT_ITEM: {
    REQUEST: `${controller}_EDIT_ITEM_REQUEST`,
    SUCCESS: `${controller}_EDIT_ITEM_SUCCESS`,
    FAILURE: `${controller}_EDIT_ITEM_FAILURE`,
  },
  EDIT_ITEM_SECTION: {
    REQUEST: `${controller}_EDIT_ITEM_SECTION_REQUEST`,
    SUCCESS: `${controller}_EDIT_ITEM_SECTION_SUCCESS`,
    FAILURE: `${controller}_EDIT_ITEM_SECTION_FAILURE`,
  },
  EDIT_ITEM_AUTO_RELOAD: {
    REQUEST: `${controller}_EDIT_ITEM_AUTO_RELOAD_REQUEST`,
    SUCCESS: `${controller}_EDIT_ITEM_AUTO_RELOAD_SUCCESS`,
    FAILURE: `${controller}_EDIT_ITEM_AUTO_RELOAD_FAILURE`,
  },
  ADD_FORM: {
    REQUEST: `${controller}_ADD_FORM_REQUEST`,
    SUCCESS: `${controller}_ADD_FORM_SUCCESS`,
    FAILURE: `${controller}_ADD_FORM_FAILURE`,
  },
  EDIT_FORM: {
    REQUEST: `${controller}_EDIT_FORM_REQUEST`,
    SUCCESS: `${controller}_EDIT_FORM_SUCCESS`,
    FAILURE: `${controller}_EDIT_FORM_FAILURE`,
  },
  REMOVE_ITEM: {
    REQUEST: `${controller}_REMOVE_ITEM_REQUEST`,
    SUCCESS: `${controller}_REMOVE_ITEM_SUCCESS`,
    FAILURE: `${controller}_REMOVE_ITEM_FAILURE`,
  },
  REMOVE_ITEM_SECTION: {
    REQUEST: `${controller}_REMOVE_ITEM_SECTION_REQUEST`,
    SUCCESS: `${controller}_REMOVE_ITEM_SECTION_SUCCESS`,
    FAILURE: `${controller}_REMOVE_ITEM_SECTION_FAILURE`,
  },
  GET_TABLE: {
    REQUEST: `${controller}_GET_TABLE_REQUEST`,
    SUCCESS: `${controller}_GET_TABLE_SUCCESS`,
    FAILURE: `${controller}_GET_TABLE_FAILURE`,
  },
  GET_TIMELINE: {
    REQUEST: `${controller}_GET_TIMELINE_REQUEST`,
    SUCCESS: `${controller}_GET_TIMELINE_SUCCESS`,
    FAILURE: `${controller}_GET_TIMELINE_FAILURE`,
  },
  GET_ENUM: {
    REQUEST: `${controller}_GET_ENUM_REQUEST`,
    SUCCESS: `${controller}_GET_ENUM_SUCCESS`,
    FAILURE: `${controller}_GET_ENUM_FAILURE`,
  },  
  GET_NODE_TYPES: {
    REQUEST: `${controller}_GET_NODE_TYPES_REQUEST`,
    SUCCESS: `${controller}_GET_NODE_TYPES_SUCCESS`,
    FAILURE: `${controller}_GET_NODE_TYPES_FAILURE`,
  },  
  GET_FLOW: {
    REQUEST: `${controller}_GET_FLOW_REQUEST`,
    SUCCESS: `${controller}_GET_FLOW_SUCCESS`,
    FAILURE: `${controller}_GET_FLOW_FAILURE`,
  },    
  GET_FLOW_OUTPUTS: {
    REQUEST: `${controller}_GET_FLOW_OUTPUTS_REQUEST`,
    SUCCESS: `${controller}_GET_FLOW_OUTPUTS_SUCCESS`,
    FAILURE: `${controller}_GET_FLOW_OUTPUTS_FAILURE`,
  },  
  POST_FLOW: {
    REQUEST: `${controller}_POST_FLOW_REQUEST`,
    SUCCESS: `${controller}_POST_FLOW_SUCCESS`,
    FAILURE: `${controller}_POST_FLOW_FAILURE`,
  },  
  GET_CONECTION_TYPES: {
    REQUEST: `${controller}_GET_CONECTION_TYPES_REQUEST`,
    SUCCESS: `${controller}_GET_CONECTION_TYPES_SUCCESS`,
    FAILURE: `${controller}_GET_CONECTION_TYPES_FAILURE`,
  },
  LOADED_PROCESSED: `${controller}_LOADED_PROCESSED`,
  SET_SELECTED_TAB: `${controller}_SET_SELECTED_TAB`,
  SET_SEARCH_TERM: `${controller}_SET_SEARCH_TERM`,
  SET_NO_SAVED_CHANGES: `${controller}_NO_SAVED_CHANGES`,
  SAVE_FLOW: `${controller}_SAVE_FLOW`,
});
